import React from "react";

const HeroCero = () => {
  return (
    <>
      <section className="hero-section position-relative min-vh-100 background-video-overly flex-column d-flex justify-content-center">
        <video
          className="fit-cover w-100 h-100 position-absolute z--1"
          autoPlay
          muted
          loop
          id="myVideo"
        >
          <source
            src="https://upgradeturismo.com.ar/ftp/homevideoupgrade.mp4"
            // IMPORTANTE
            // Para la ejecucion correcta de esto lA ruta de este video tiene que estar hosteada en la nube publica de un servidor.
            type="video/mp4"
          />
        </video>
        <div className="container">
          <div className="row align-items-center justify-content-center">
            <div className="col-md-8 col-lg-8">
              <div className="hero-content-left text-white text-center mt-5 ptb-100">
                <h1 className="text-white">¡Bienvenido a Upgrade Turismo!</h1>
                <p className="lead">
                  Nos especializamos en crear experiencias inolvidables para
                  estudiantes que desean vivir una experiencia única en su viaje
                  de egresados. Desde aventuras educativas hasta fiestas
                  inolvidables, estamos aquí para llevar tu viaje al siguiente
                  nivel.{" "}
                </p>

                <a href="https://cotizador.upgradeturismo.com.ar/new/home" className="btn google-play-btn">
                  Cotiza tu viaje
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default HeroCero;
